import { Blog } from "../../models/blog.model";

export const blogsSelector = (store) => Blog.fromList(store.blogs.blogs);

export const featuredBlogSelector = (store) =>
  new Blog(store.blogs.featuredBlog);

export const blogSelector = (store) => new Blog(store.blog.blog);
